/**
 * PoppinPay API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import DeliveryAddressModel from './DeliveryAddressModel';

/**
* The DeliveryAddressListResultModel model module.
* @module model/DeliveryAddressListResultModel
* @version 1.0.0
*/
export default class DeliveryAddressListResultModel {
    /**
    * Constructs a new <code>DeliveryAddressListResultModel</code>.
    * @alias module:model/DeliveryAddressListResultModel
    * @class
    */

    constructor() {
        
        
        
    }

    /**
    * Constructs a <code>DeliveryAddressListResultModel</code> from a plain JavaScript object, optionally creating a new instance.
    * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
    * @param {Object} data The plain JavaScript object bearing properties of interest.
    * @param {module:model/DeliveryAddressListResultModel} obj Optional instance to populate.
    * @return {module:model/DeliveryAddressListResultModel} The populated <code>DeliveryAddressListResultModel</code> instance.
    */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new DeliveryAddressListResultModel();
                        
            
            if (data.hasOwnProperty('DeliveryAddresses')) {
                obj['DeliveryAddresses'] = ApiClient.convertToType(data['DeliveryAddresses'], [DeliveryAddressModel]);
            }
        }
        return obj;
    }

    /**
    * @member {Array.<module:model/DeliveryAddressModel>} DeliveryAddresses
    */
    'DeliveryAddresses' = undefined;




}
